import Vue from 'vue';
// @ts-ignore

import VueCompositionAPI from '@vue/composition-api';

import App from '@/App.vue';
import ContextInfo from '@/data/settings/ContextInfo';
import SharedState from '@/data/SharedState';

//@ts-ignore
Vue.prototype.$videoPlayer = window.VideoPlayer;

Vue.use(VueCompositionAPI);

Vue.config.productionTip = false

const elems = document.getElementsByClassName('corp-tube');

Array.from(elems).forEach((element) => {

  const attrsObject: Record<string, string> = {};
  for(const attr of element.attributes) {
    attrsObject[attr.name] = attr.value;
  }
  const contextInfo = new ContextInfo(element.id);
  contextInfo.readFrom(attrsObject);
  contextInfo.setRegionByCountryIf();

  const sharedState = new SharedState(contextInfo);

  const getVideoIdFromUrlHash = (urlHash: string): string | undefined => {
    if(urlHash && urlHash.length > 1) {
      return urlHash.substring(1);
    }
    return undefined;
  }

  new Vue({
    data: {
      sharedState,
    },
    /* eslint-disable-next-line  @typescript-eslint/no-explicit-any */
    render: (h: (arg0: any, arg1: { props: { contextInfo: ContextInfo; videoId: string | undefined } }) => any) => h(
      App, {
        props: {
          contextInfo: contextInfo,
          videoId: getVideoIdFromUrlHash(window.location.hash)
        }
      })
    }).$mount('#' + element.id)
});
